module.exports = __webpack_public_path__ + "img/9.28b67bb0.png";